import { useSelector } from 'react-redux';
import { useCallback } from 'react';
import { useCities } from './useCities';

export const useMapperAddress = () => {
  const { cities } = useCities(false);
  const {
    values: {
      2: { locationLat = null, locationLong = null } = {},
      0: { address = null, streetNumber = null, cityId = null } = {},
    } = {},
    aux: {
      currentLat = null,
      currentLng = null,
      currentCity = null,
      currentState = null,
      currentCountry = null,
    } = {},
  } = useSelector((state: any) => state.processComplate);

  const {
    address: addressServer,
    cityId: cityIdServer,
    locationLat: locationLatServer,
    locationLong: locationLongServer,
  } = useSelector((state: any) => state.profile.data);

  const getShortAddressAndStreetNumber = useCallback((): {
    street: string;
    streetNumber: number;
  } => {
    const firstPart = addressServer?.split(',')?.[0];
    const parts = firstPart?.split(' ');
    const streetNumber = parts?.pop();
    const street = parts?.join(' ');
    return {
      street,
      streetNumber,
    };
  }, [addressServer]);

  const getLongAddress = useCallback(() => {
    const { streetNumber: streetNumberServer } =
      getShortAddressAndStreetNumber();

    const { label: cityLabel, state } =
      cities.find(({ id }) => (cityId || cityIdServer) === id) || {};

    return `${(address || addressServer).trim()} ${
      streetNumber || streetNumberServer
    }, ${cityLabel || currentCity}, ${state || currentState}, ${
      currentCountry || 'ARG'
    }`;
  }, [
    address,
    addressServer,
    cities,
    cityId,
    cityIdServer,
    currentCity,
    currentCountry,
    currentState,
    getShortAddressAndStreetNumber,
    streetNumber,
  ]);

  return {
    getLongAddress,
    getShortAddressAndStreetNumber,
    location: {
      currentLat,
      currentLng,
      locationLat: locationLat || locationLatServer,
      locationLong: locationLong || locationLongServer,
    },
  };
};
